var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9566 7.22161C11.0806 7.22161 9.72458 6.22561 8.29658 6.26161C6.41258 6.28561 4.68458 7.35361 3.71258 9.04561C1.75658 12.4416 3.20858 17.4576 5.11658 20.2176C6.05258 21.5616 7.15658 23.0736 8.62058 23.0256C10.0246 22.9656 10.5526 22.1136 12.2566 22.1136C13.9486 22.1136 14.4286 23.0256 15.9166 22.9896C17.4286 22.9656 18.3886 21.6216 19.3126 20.2656C20.3806 18.7056 20.8246 17.1936 20.8486 17.1096C20.8126 17.0976 17.9086 15.9816 17.8726 12.6216C17.8486 9.81361 20.1646 8.46961 20.2726 8.40961C18.9526 6.47761 16.9246 6.26161 16.2166 6.21361C14.3686 6.06961 12.8206 7.22161 11.9566 7.22161V7.22161ZM15.0766 4.38961C15.8566 3.45361 16.3726 2.14561 16.2286 0.849609C15.1126 0.897609 13.7686 1.59361 12.9646 2.52961C12.2446 3.35761 11.6206 4.68961 11.7886 5.96161C13.0246 6.05761 14.2966 5.32561 15.0766 4.38961V4.38961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e6af30a884c20b3478c5f26093688124.svg";
export { ForwardRef as ReactComponent };